import { appinfo } from "./appinfo";

export const environment = {
  name: appinfo.name,
  version: appinfo.version,
  build_id: appinfo.build_id,
  build_nbr: appinfo.build_nbr,
  build_commit: appinfo.build_commit,
  build_date: appinfo.build_date,
  production: true,
  mock: false,
  enableGraphFeatures: true,
  pdfViewerLogLevel: 1,
  apiUrl: 'https://api.markadoc.com',
  mailApiUrl: 'https://sysmail.markadoc.com'
};
